import { useState, useCallback } from "react";

export function useToggle(
	initial: boolean = false
) : [
	boolean,
	(value?: boolean) => void
] {
	const [value, setValue] = useState(initial);

	const toggle = useCallback(
		(value?: boolean): void => {
			setValue((prevState) => value ?? !prevState);
		},
		[]
	);

	return [value, toggle];
};
